<template>
    <h2 class="headline font-weight-bold align-baseline"
        :class="{ 'px-7 px-lg-0 pt-5 mb-3': !classes, [classes]: classes }">
        <template v-if="!loading">
            <slot></slot>
        </template>
        <v-skeleton-loader type="heading" v-else />
    </h2>
</template>

<script>
    export default {
        name: 'heading-section',
        props: {
            classes: {
                default: false,
            },
            loading: {
                required: false,
                type: Boolean,
            },
        },
    }
</script>
